import React from "react";
import { useSpring, animated, useInView } from "@react-spring/web";

const PopUp = ({ children }) => {
  const [ref, inView] = useInView({ threshold: 0.5, once: true }); // Adjust the threshold as needed

  const props = useSpring({
    to: {
      opacity: inView ? 1 : 0,
      transform: inView ? "scale(1)" : "scale(0)"
    },
    from: {
      opacity: 0,
      transform: "scale(0)"
    },
    config: { mass: 4, tension: 180, friction: 30 }
  });

  return (
    <div ref={ref}>
      <animated.div style={props}>{children}</animated.div>
    </div>
  );
};

export default PopUp;
